export default __webpack_public_path__ + "static/media/supper_apps_s3.8f551d08.png";